import React from 'react'
import image from '../assets/images/invest_ilust1.png'
import { useHistory} from 'react-router-dom'


const Index = () => {
    const history = useHistory()
    if (sessionStorage.getItem('idToken')) {
        setTimeout(() => {
            history.push('/dashboard')
        }, 3000);
    }
    setTimeout(() => {
        history.push('/signin')
    }, 3500);
    return (
        <>
            <div className="body bg-dark">
                <img alt="pouch" src={image} className="splash-img" />      
            </div>
        </>
    )
}

export default Index


